import { Context } from 'react'
import { IMainComponent } from 'src/generated-types/main-component'
import WashingReports from '../WashingReports'
import { WashingReportDto } from 'src/generated-types/washing-report-dto'

interface Props {
  context: Context<any> | null | undefined
  mainComponentId: any
  mainComponent: IMainComponent
  onAddWashingReport: (initialValues: WashingReportDto | undefined) => void
  positionId?: EntityId
  height?: string
  autoHeight?: boolean
  maxVisibleRowCount?: number
  minimalEmptyStatus?: boolean
  setDataLength?: (length: number) => void
  disabled?: boolean
}

const WashingReportsInEquipment = (props: Props) => {
  const {
    context,
    mainComponentId,
    positionId,
    height,
    autoHeight,
    maxVisibleRowCount,
    minimalEmptyStatus,
    setDataLength,
    disabled,
  } = props

  return (
    <WashingReports
      mainComponentId={mainComponentId}
      context={context}
      withoutLayout={true}
      onAddWashingReport={props.onAddWashingReport}
      positionId={positionId}
      height={height}
      autoHeight={autoHeight}
      maxVisibleRowCount={maxVisibleRowCount}
      minimalEmptyStatus={minimalEmptyStatus}
      setDataLength={setDataLength}
      disabled={disabled}
    />
  )
}

export default WashingReportsInEquipment
